enum BlackConnectionEnum {
  OUT = 'BlackListOut',
  IN = 'BlackListIn',
  OUT_INTERACTION = 'BlackListOutInteraction',
}

export { BlackConnectionEnum };
